import { render, staticRenderFns } from "./ContextMenu.vue?vue&type=template&id=a0a08f44&scoped=true"
import script from "./ContextMenu.vue?vue&type=script&lang=ts"
export * from "./ContextMenu.vue?vue&type=script&lang=ts"
import style0 from "./ContextMenu.vue?vue&type=style&index=0&id=a0a08f44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a08f44",
  null
  
)

export default component.exports